import { Languages } from "lucide-react";
import { useLang } from "../lib/i18n";
import { Tip } from "./Tip";

export const LangToggle = ({ compact = false }) => {
  const { lang, setLang, langs } = useLang();
  return (
    <Tip label={lang === "es" ? "Cambiar el idioma de la aplicación" : "Switch the app language"}>
      <div data-testid="lang-toggle" className={`inline-flex items-center rounded-full border border-border bg-card p-0.5 ${compact ? "" : "gap-0.5"}`}>
        {!compact && <Languages className="h-3.5 w-3.5 text-muted-foreground ml-1.5 mr-0.5" />}
        {Object.keys(langs).map((code) => (
          <button
            key={code}
            type="button"
            data-testid={`lang-${code}`}
            aria-pressed={lang === code}
            onClick={() => setLang(code)}
            className={`h-7 px-2 rounded-full text-[11px] font-mono uppercase tracking-wider transition-colors ${lang === code ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}
          >
            {code}
          </button>
        ))}
      </div>
    </Tip>
  );
};
